import gsap, { Quint } from "gsap"

const accordion = () => {
  const targets = document.querySelectorAll('.js-accordion')

  if (targets.length > 0) {
    targets.forEach((el) => {
      const tab = el.querySelector('.js-accordion-tab'),
        panel = el.querySelector('.js-accordion-panel'),
        panelReverse = el.querySelector('.js-accordion-panel-reverse'),
        arrow = el.querySelector('.js-accordion-arrow')

      let open = false

      if(el.classList.contains('hover')) {
        el.addEventListener('mouseover', () => {
          gsap.to(panel, {
            height: 'auto',
            duration: 0.6,
            ease: Quint.easeInOut,
          })
          
          gsap.to(arrow, {
            rotate: 180,
            duration: 0.4,
            ease: Quint.easeOut,
          })
        })

        el.addEventListener('mouseleave', () => {
          gsap.to(panel, {
            height: 0,
            duration: 0.6,
            ease: Quint.easeInOut,
          })
          
          gsap.to(arrow, {
            rotate: 0,
            duration: 0.4,
            ease: Quint.easeOut,
          })
        })
      } else {
        const closeAnim = gsap.timeline();
        const openAnim = gsap.timeline();
        tab.addEventListener('click', () => {
          if (open) {
            closeAnim
              .to(panel, {
                height: 0,
                duration: 0.6,
                ease: Quint.easeInOut,
              })
            
            if(panelReverse) {
              closeAnim
                .to(panelReverse, {
                  height: 'auto',
                  duration: 0.6,
                  ease: Quint.easeInOut,
                }, '-=.2')
            }
            
            closeAnim
              .to(arrow, {
                rotate: 0,
                duration: 0.4,
                ease: Quint.easeOut,
              }, '<')
          } else {
            if(panelReverse) {
              openAnim
                .to(panelReverse, {
                  height: 0,
                  duration: 0.6,
                  ease: Quint.easeInOut,
                })
            }

            openAnim
              .to(panel, {
                height: 'auto',
                duration: 0.6,
                ease: Quint.easeInOut,
              }, '-=.2')
            
              .to(arrow, {
                rotate: 180,
                duration: 0.4,
                ease: Quint.easeOut,
              }, '<')
          }
          
          open = !open
        })
      }
    })
  }
}

export default accordion